/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: utils/formDefaults.ts (Ring Groups)
 🗓️ Created: 2025-01-15
 🧩 Description:
    Default form state values for Ring Groups module.

────────────────────────────────────────────────────────────────*/

import { FormState, MappedFormState } from '../types';

/**
 * Default form state
 */
export function getDefaultFormState(): FormState {
  return {
    name: '',
    extension: '',
    context: 'default',
    strategy: 'simultaneous',
    ringTimeout: '30',
    fallbackModule: 'none',
    fallbackValue: '',
    callerIdName: '',
    callerIdNumber: '',
    distinctiveRing: '',
    ringback: '${us-ring}',
    greeting: '',
    callScreen: 'disabled',
    callForward: 'disabled',
    followMe: 'disabled',
    missedCallAction: 'none',
    forwardEnabled: 'disabled',
    forwardNumber: '',
    forwardTollAllow: '',
    confirmKey: '1',
    confirmFile: 'ivr/press_1_to_accept.wav',
    presenceId: '',
    record: false,
    callTimeoutOverride: '',
    skipBusy: false,
    enabled: true,
    description: '',
    createdAt: null,
    updatedAt: null
  };
}

/**
 * Default mapped form state (includes members and extra settings)
 */
export function getDefaultMappedFormState(): MappedFormState {
  return {
    formState: getDefaultFormState(),
    members: [],
    extraSettings: {}
  };
}

/**
 * Strategy options
 */
export const STRATEGY_OPTIONS: Array<'simultaneous' | 'sequence' | 'enterprise' | 'random' | 'rollover'> = [
  'simultaneous',
  'sequence',
  'enterprise',
  'random',
  'rollover'
];

